import { BowtieCaseModel } from '../types';
import { ConnectedCase, ConnectedCasesModel } from '../types-store';
import { flattenAnchorRoots } from './map-anchor';

export const filterConnectedCases = (
  activeElementCaseNumber: number,
  connectedCases: ConnectedCasesModel[],
  bowtieCaseModel: BowtieCaseModel
): ConnectedCase[] => {

  const allElementsCaseNumbers = flattenAnchorRoots(bowtieCaseModel?.anchors);

  return connectedCases
    ?.find(model => model.caseId === activeElementCaseNumber)
    ?.connected
    ?.filter(connected => !allElementsCaseNumbers.includes(connected.caseId))
    ?? [];
};
